import { render, staticRenderFns } from "./GrupoDeZona.vue?vue&type=template&id=0c743519&"
import script from "./GrupoDeZona.vue?vue&type=script&lang=ts&"
export * from "./GrupoDeZona.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports